<div id="bb-worklist" *ngIf="worklistService.shouldShow()" [ngClass]="{'is-open':worklist.isOpen}" class="inner-shadow">
	<div class="worklist-wrapper">
		<div class="toggle-handle"
		[hidden]="!worklist.isOpen && !worklist.items?.length"
		(click)="worklistService.toggle()"
		title="{{ (!worklist.isOpen ? 'SHOW_WORKLIST_CONTAINING_X_ITEMS':'HIDE_WORKLIST') | translate:{x:worklist.items?.length} }}">
			<i *ngIf="!worklist.isOpen" class="fa fa-angle-left"></i>
			<i *ngIf="worklist.isOpen" class="fa fa-angle-right"></i>
			<div class="count" *ngIf="!worklist.isOpen">
				{{worklist.items?.length}}
			</div>
		</div>
		<div class="content">
			<div class="worklist-title">
				<div (click)="worklistService.clear()" class="remove-item" *ngIf="worklist.isOpen" title="{{'EMPTY_WORKLIST' | translate}}"><i class="fa fa-trash"></i></div>
				<label *ngIf="worklist.items?.length > 1">{{'WORKLIST_CONTAINING_X_ITEMS' | translate:{x:worklist.items?.length} }}</label>
				<label *ngIf="worklist.items?.length === 1">{{'WORKLIST_CONTAINING_ONE_ITEM' | translate}}</label>
				<label *ngIf="worklist.items?.length === 0">{{'EMPTY_WORKLIST' | translate }}</label>
			</div>
			<ul class="worklist-items" *ngIf="worklist && worklist.items && worklist.items.length">
				<li *ngFor="let item of worklist.items; let myIndex = index;" class="worklist-item" [ngClass]="{active:isActiveItem(item)}" (click)="worklistService.setActiveItem(item)">
					<div class="remove-item" (click)="worklistService.removeItemsById([item.id])"><i class="fa fa-times"></i></div>
					<div class="active-indictator"><i class="fa fa-caret"></i></div>
					<a class="item-link" (click)="tempNav(item)">
						<div class="title-and-status">
							<span class="item-title" [innerHTML]="item | clipTitle"></span>
							<span [innerHTML]="item | statusIcon"></span>
						</div>
						<div class="type-and-id">
								<span [innerHTML]="item.mediatype | mediatypeIcon" class="item-mediatype-icon"></span>
								{{item?.id}}
						</div>
					</a>
				</li>
			</ul>
			<div class="worklist-shortcuts-text">
				<span (click)="worklistService.previous()">{{ isOSX() ? '⌘' : 'ctrl' }} + &uarr;</span> and
				<span (click)="worklistService.next()">{{ isOSX() ? '⌘' : 'ctrl' }} + &darr;</span> to navigate
			</div>
		</div>
	</div>
</div>
